import { ReduxUtils } from '@dw/pwa-helpers/redux-utils';
import * as actions from './actions.js';

/**
 * Card detail page reducer
 */
export const cardDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.UPDATE_DESCRIPTION_DRAFT: {
      if (!action.cardId) {
        return state;
      }

      // No description means the edit is over — saved, cancelled or discarded — so the key goes
      // rather than being left behind for every card the user has ever opened.
      const draft = action.description === undefined
        ? undefined
        : { description: action.description, originalDescription: action.originalDescription };
      return ReduxUtils.replace(state, `descriptionDrafts.${action.cardId}`, draft);
    }

    case actions.CLEAR_DESCRIPTION_DRAFTS:
      return { ...state, descriptionDrafts: undefined };

    case actions.UPDATE_LOCAL_CARD_TITLE:
      return ReduxUtils.replace(state, `/cardTitle/${action.cardId}`, action.title, '/');
    case actions.DIALOG_OPENED:
    case actions.DIALOG_CHANGED:
      return ReduxUtils.replace(state, `openCardStatus.${action.cardId}`, { loaded: false });
    case actions.DIALOG_CLOSED:
      return ReduxUtils.replace(state, `openCardStatus.${action.cardId}`, undefined);
    case actions.DIALOG_DATA_LOADED:
      return ReduxUtils.replace(state, `openCardStatus.${action.cardId}`, { loaded: true, deleted: action.deleted || false });
    case actions.UPDATE_DELETED:
      return ReduxUtils.replace(state, `openCardStatus.${action.cardId}.deleted`, action.deleted || false);
    default:
      return state;
  }
};